import { render, staticRenderFns } from "./ModalAddChildLocation.vue?vue&type=template&id=a9c54036&scoped=true&"
import script from "./ModalAddChildLocation.vue?vue&type=script&lang=js&"
export * from "./ModalAddChildLocation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9c54036",
  null
  
)

export default component.exports